<template>
  <div class="container-fluid">
    <div class="row page-title align-items-center">
      <div class="col-sm-4 col-xl-4">
        <h4 class="mb-1 mt-0">{{$t('dashboard.welcome_title')}} {{ user.full_name }}!</h4>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-4 header-title">{{$t('dashboard.pending_consent')}}
              <!-- <button class="btn btn-primary float-right btn-sm" @click="viewApplicationList">View List</button> -->
            </h5>

            <div class="custom-list" :style="{
              'display': (pendingConsent.length ? 'block' : 'flex')
            }">
              <VuePerfectScrollbar style="height: 600px" v-if="pendingConsent.length">
                <div class="media mt-1 border-top pt-3 px-2 cursor-pointer clickable" v-for="(consent, idx) in pendingConsent" :key="idx"
                  @click="viewApplication({application:consent})"
                >
                  <img :src="consent.candidate_id ? consent.candidate_id.avatar_path : consent.prospect ? consent.prospect.avatar_path : consent.prospect" class="avatar rounded mr-3" />
                  <div class="media-body">
                    <h6 class="mt-1 mb-0 font-size-15">{{ consent.candidate_id ? consent.candidate_id.full_name : consent.prospect ? consent.prospect.full_name : consent.prospect }} 
                      <span class="small font-weight-bold" v-if="consent.reference_no">#{{consent.reference_no}}</span>
                    </h6>
                    <div class="text-muted font-weight-normal small">Waiting for his/her consent to proceed.</div>
                    <div class="text-muted font-weight-bold small">{{!consent.job_id ? 'N/A' : 'Applying for '+consent.job_id.title + ` (#${consent.job_id.reference_no})`}}</div>
                    <div class="text-muted font-weight-bold small">
                      {{!consent.job_id ? 'N/A' : `${consent.job_id.company_id.name} | Uploaded by: ${consent.user && consent.user.company ? consent.user.company_name + ' - ' + consent.user.full_name : consent.user.parent_id && consent.user.parent_id.company ? consent.user.parent_id.company_name + ' - ' + consent.user.full_name : 'Individual - ' + consent.user.full_name}
                      `}}
                    </div>
                  </div>
                  <!-- <div classs="btn-group float-right">
                    <button class="btn2 btn2-primary btn-sm">Approved</button> <button class="btn btn-danger btn-sm">Disapproved</button>
                  </div> -->
                  <div class="float-right m-auto">
                    <feather
                      type="eye"
                      class="icon-md"
                    ></feather>
                  </div>
                </div>
              </VuePerfectScrollbar>

              <div class="text-center" style="margin:auto" v-if="!pendingConsent.length">
                <feather
                  type="tag"
                  class="icon-xl"
                ></feather>
                <div>No pending consent.</div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-lg-8 col-md-4 full-width">
        <DataTable ref="list" :type.sync="type" :isDashboard="true"/>
      </div>

      <Dialog
        ref="viewApplication"
        centered
        size="xl"
        title="View Application"
        bodyClass="modalBodyContainer px-4"
        :component="computedViewApplication"
        :parameters="{ applicationID }"
      />
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import FormMixin from '@mixins/form'
import DataTable from '@common/datatable2'
import Dialog from '@components/dialogs'

export default {
  mixins:[FormMixin],
  name: 'Home',
  components:{
    VuePerfectScrollbar,
    DataTable,
    Dialog
  },
  computed: {
    computedViewApplication() {
      return () => import('@pages/application/components/dialogs/view')
    }
  },
  data() {
		return {
      prospectID: '',
      applicationID: '',
      statData: [],
      pendingConsent: [],
      pendingApproval: [],
      membersData: [
        {
          image:'/img/avatar-7.bae8e081.jpg',
          name:'Text',
          text:'name'
        },
        {
          image:'/img/avatar-7.bae8e081.jpg',
          name:'Text',
          text:'name'
        }
      ],
      type: 'active'
    }
  },
  methods:{
    ...mapActions('dashboard', ['dashboard']),
    viewApplication(item){
      let application = (typeof item.application === 'object') ? item.application._id : item.application
      this.applicationID = application
      this.prospectID = item._id
      this.$refs.viewApplication.show()

      // this.$router.push(`/application/view?` + (application ? `id=${application}` : `prospect=${item._id}`))
    },
    viewApplicationList(){

    },
    toggleApprove(item, approve){
      if(!item){
        alert('Missing application link, please coordinate with administrator.')
        return false
      }

      if(!this.loading)
      this.$bvModal.msgBoxConfirm('Are you sure you want to '+(approve ? 'Approve' : 'Reject')+' application?', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: approve ? 'success' : 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()
          this.$store.dispatch('application/approve', {
            id:item._id,
            approve:approve
          }).then((res) => {
            this.fetchData()
            this.$bvToast.toast(res.data.approved ? `Successfully Approved!` : 'Sucessfully Rejected!', {
              title: 'Notification',
              variant:res.data.approved ? 'success' : 'danger'
            })
            this.toggleLoading()
          })
        }
      })
    },
    fetchData(){
      this.dashboard().then(res => {
        this.statData = res.data.stats
        this.pendingConsent = res.data.pendingConsent
        this.pendingApproval = res.data.pendingApproval
      })
    },
    goToLink(stat){
      this.$router.push(stat.link)
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style lang="scss">
  .cursor-pointer{
    cursor: pointer;
  }

  .clickable:hover{
    background:#f5f5f5
  }

  .custom-list{
    min-height: 600px;
    max-height: 600px;
  }

  .modalBodyContainer {
    background: #e8eaee;
    overflow: auto;
    height: 80vh;
  }

</style>
